import { IMappingFiltersState } from './mappingFilters.interface';

export const initialState: IMappingFiltersState = {
  showFiltersModal: false,
  copiedMappingFilters: [],
  copiedFilterPropType: '',
};
